import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import AppRoutes from './routes/AppRoutes';
import { GTMInjector } from './GTMInjector';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const GTMNoScript = () => (
  <noscript>
    <iframe
      src="https://www.googletagmanager.com/ns.html?id=GTM-TN7Z9FQN"
      height="0"
      width="0"
      style={{ display: 'none', visibility: 'hidden' }}
      title="gtm"
    ></iframe>
  </noscript>
);

root.render(
  <React.StrictMode>
    <GTMInjector />
    <GTMNoScript />
    <AppRoutes />
  </React.StrictMode>,
);

reportWebVitals();
